import { HoverOver } from '../../../../../../../../../GlobalComponents/Builders';
import { FileText } from 'react-feather';

const EFFECT_LABELS = { 0: 'Always', 1: 'Create', 2: 'Update' };
const EFFECT_TYPES = { 0: 'effect', 1: 'effect-create', 2: 'effect-update' };
const ORDER_LABELS = { 0: 'First', 1: 'Second', 2: 'Third', 3: 'Default', 4: 'Next', 5: 'Last' };
const ORDER_TITLES = { 0: 'Run first', 1: 'Run second', 2: 'Run third', 3: 'Default order', 4: 'Run next', 5: 'Run last' };
const FAIL_CLASS = { Retry: 'fail-retry', Skip: 'fail-skip', Delete: 'fail-delete' };

const Tag = ({ label, title, type, isDefault }) => (
    <span title={title} className={`config-tag config-tag--${type} config-tag--${isDefault ? 'outline' : 'solid'}`}>
        {label}
    </span>
);

const KeyMappingConfig = ({ row, showNotes = true, nowrap = false }) => (
    <div className='config-tags' style={nowrap ? { flexWrap: 'nowrap' } : undefined}>
        <Tag label={EFFECT_LABELS[row.take_effect_on] || '?'} title={`Takes effect: ${EFFECT_LABELS[row.take_effect_on] || '?'}`}
            type={EFFECT_TYPES[row.take_effect_on] || 'effect'} isDefault={row.take_effect_on === 0} />
        <Tag label={ORDER_LABELS[row.order] ?? '–'} title={`Order: ${ORDER_TITLES[row.order] || 'Unknown'}`}
            type='order' isDefault={row.order === 3} />
        <Tag label={row.on_failure || 'Retry'} title={`On failure: ${row.on_failure || 'Retry'}`}
            type={FAIL_CLASS[row.on_failure] || 'fail-retry'} isDefault={!row.on_failure || row.on_failure === 'Retry'} />
        {showNotes ? (row.notes
            ? <HoverOver content={row.notes} text={<FileText size={15} className='icon-solid-secondary' style={{ cursor: 'pointer', verticalAlign: 'middle' }} />} textStyle={{ minWidth: 0, flex: '0 0 auto', display: 'flex', alignItems: 'center' }} contentStyle={{ maxWidth: 400 }} />
            : <FileText size={11} style={{ color: '#ccc', verticalAlign: 'middle' }} />) : null}
    </div>
);

export default KeyMappingConfig;
